import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../../hooks/auth/use-logout/use-logout";
import { ErrorMessage } from "../../components/poppers/ErrorMessage";
import { useModal } from "../../hooks/useDialog";

export function LoginErrorModal() {
  const { close } = useModal();
  const navigate = useNavigate();
  const { logout } = useLogout();

  return (
    <ErrorMessage title="Ops, qualcosa è andato storto!">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          Il metodo di accesso che hai scelto non ha risposto correttamente.
          <br />
          Riprova, oppure scegli un altro metodo.
        </Grid>
        <Grid item xs={12} css={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              logout().finally(() => {
                close();
                navigate("/welcome");
              });
            }}
          >
            Torna indietro
          </Button>
        </Grid>
      </Grid>
    </ErrorMessage>
  );
}
